import { render } from "./form6.vue?vue&type=template&id=7d20e857"
import script from "./form6.vue?vue&type=script&lang=js"
export * from "./form6.vue?vue&type=script&lang=js"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__